export enum EnumPaymentStatus {
  PENDING_PAYMENT = "pending_payment",
  SUCCESS = "success",
  CANCELLED = "cancelled",
}
